module.exports = function () {
  const el = document.querySelector('.sample-box');
  console.log('Sample box initialized');
  if (el) {
    const cartButton = el.querySelector('.sample-box__cart-btn');
    const productAdded = el.querySelector('.sample-box__cart-btn--added');
    const secondaryLink = el.querySelector('.sample-box__secondary-link');
    const quantitySelect = el.querySelector('.sample-box__select--quantity');
    const typeSelect = el.querySelector('.sample-box__select--type');
    const notificationBox = el.querySelector('.sample-box__notification-box');
    const notificationTitle = el.querySelector('.sample-box__notification-box-title');
    const notificationDescription = el.querySelector('.sample-box__notification-box-message');
    const notificationCloseButton = el.querySelector('.sample-box__notification-box__close-button');
    const addCartEndpoint = el.dataset.addItemEndpoint;
    const removeCartEndpoint = el.dataset.removeItemEndpoint;
    const isUserLoggedIn = el.dataset.userLogin;

    if (productAdded && isUserLoggedIn) {
      cartButton.classList.add('sample-box__cart-btn--added');
      cartButton.innerText = 'Update Cart';
    }

    if (isUserLoggedIn && isUserLoggedIn) {
      secondaryLink.innerText = 'Remove from cart'
    }

    function animateClose() {
      setTimeout(() => {
        notificationBox.style.transform = 'translateY(-200%)';
      }, 5000);
    }

    if (cartButton) {
      cartButton.addEventListener('click', (e) => {
        e.preventDefault();

        const productId = cartButton.dataset.id;
        const selectQuantity = quantitySelect.value;
        let selectType = '';

        if (typeSelect) {
          selectType = `&type=${typeSelect.value}`;
        }

        fetch(`${addCartEndpoint}?productId=${productId}&quantity=${selectQuantity}${selectType ? selectType : ''}`).then(res => res.json())
          .then(data => {
            if (data.Success) {
              cartButton.classList.add('sample-box__cart-btn--added');
              cartButton.innerText = 'Update Cart';
              const cart = document.querySelector('.header-login-control .login-modal-cart-item-count');

              cart.innerText = `(${data.NumberOfItemsInCart})`;

              notificationTitle.innerText = data.MessageTitle;
              notificationDescription.innerText = data.MessageDescription;
              notificationBox.style.transform = 'translateY(0)';

              animateClose();
            }
          });


      })
    }

    if (secondaryLink && isUserLoggedIn) {
      secondaryLink.addEventListener('click', (e) => {
        e.preventDefault();
        const productId = cartButton.dataset.id;

        fetch(`${removeCartEndpoint}?productId=${productId}`).then(res => res.json())
          .then(data => {
            if (data.Success) {
              const cart = document.querySelector('.header-login-control .login-modal-cart-item-count');
              cart.innerText = `(${data.NumberOfItemsInCart})`;

              notificationTitle.innerText = data.MessageTitle;
              notificationDescription.innerText = data.MessageDescription;
              notificationBox.style.transform = 'translateY(0)';

              if (data.ProductQuantity === 0) {
                cartButton.classList.remove('sample-box__cart-btn--added');
                cartButton.innerText = 'Add to Cart';
              }

              animateClose();
            }
          })

      })
    }

    if (notificationCloseButton) {
      notificationCloseButton.addEventListener('click', (e) => {
        notificationBox.style.transform = 'translateY(-200%)';
      })
    }
  }
}
